import {GET, POST, PUT, CONTENT_TYPE_JSON} from "../../util/http.js";


const httpJsonRequest = function (method, url, data, options = {}) {
    return jQuery.ajax({
        url: url,
        data: method === PUT || method === POST ? JSON.stringify(data) : undefined,
        method: method,
        contentType: CONTENT_TYPE_JSON,
        headers: {
            Authorization: `Bearer ${getToken(options.namespace || '')}`,
            'X-Pk-Chat-Namespace': options.namespace || '',
        }
    }).then((data, status, jqXHR) => {
        if (jqXHR.getResponseHeader('X-Pk-Chat-Token')) {
            setToken(options.namespace || '', jqXHR.getResponseHeader('X-Pk-Chat-Token'));
        }
        return data;
    });
};


const getTokenNamespacedParam = (namespace = '') => `pk-chat-access-token` + (namespace ? `-${namespace}` : '');
export const getToken = (namespace = '') => window.localStorage.getItem(getTokenNamespacedParam(namespace));
export const setToken = (namespace = '', token) => window.localStorage.setItem(getTokenNamespacedParam(namespace), token);

export const httpGet = (url, options = {}) => httpJsonRequest(GET, url, null, options);
export const httpPut = (url, data, options = {}) => httpJsonRequest(PUT, url, data, options);
export const httpPost = (url, data, options = {}) => httpJsonRequest(POST, url, data, options);
